import React from 'react'

import './LoseScreen.scss'
import { fCurrency } from 'helpers/common'
import { PriceRange } from 'hooks/useDetailedBetResult'
import speedometer from 'assets/animation/lose_speedometer.webp'
import Background from 'assets/win_screen_point_bg.png'
import { useAppContext } from 'context/AppContext'

interface LoseScreenProps {
  priceRange: PriceRange
  percentageChange: string
}

const LoseScreen: React.FC<LoseScreenProps> = ({
  percentageChange,
  priceRange,
}) => {
  const { pointsSettings } = useAppContext()

  return (
    <div className="LoseScreen">
      <div className="LoseScreen__title">Lose</div>

      <div>
        <div className="LoseScreen__percentage">
          <span>BTC Price</span>{' '}
          <span className="LoseScreen__percentage-percent">
            {percentageChange}%
          </span>
        </div>
        <div className="LoseScreen__price-range">
          From {fCurrency(priceRange.from)} to {fCurrency(priceRange.to)}
        </div>
      </div>

      <img src={speedometer} alt="WebP Animation" width={450} />

      <div className="LoseScreen__main-points-wrapper">
        <div className="LoseScreen__points-wrapper">
          {pointsSettings && (
            <div className="LoseScreen__points">
              - {+pointsSettings.win / 2} pts
            </div>
          )}
        </div>

        <img
          className="LoseScreen__points-bg"
          width={480}
          height={129}
          src={Background}
          alt="background"
        />
      </div>
    </div>
  )
}

export default LoseScreen
